export const SITE_TITLE = "Inference.net Documentation";
export const SITE_DESCRIPTION =
  "Use Inference.net to observe, evaluate, train, and deploy LLM systems.";
export const SITE_URL = "https://docs.inference.net";
